<template>
	<div class="input-wrapper">
		<div class="label__content">
			<TypographyKTypographyBody5
				class="label"
				:color="'var(--color_font_black_wite)'"
				font-type="semi-bold"
				>{{ label }}</TypographyKTypographyBody5
			>
			<UiInput
				v-if="modelValue || isNeedAlwaysVisibleInput"
				v-model="modelValue"
				:placeholder="placeholder"
				:readonly="readonly"
				:suggestions="suggestions"
				:isVisibleSuggestionsDefault="isVisibleSuggestionsDefault"
				@chooseSuggestion="chooseSuggestion"
			>
				<template
					#left-icon
					v-if="$slots?.['left-icon']"
				>
					<slot name="left-icon" />
				</template>
			</UiInput>
		</div>
		<UiButton
			:label="btnTitle || (modelValue ? 'Изменить' : '+ Добавить')"
			:size="ButtonSizeType.small"
			:color="ButtonType.primary"
			v-if="isNeedChangeBtn"
			class="btn"
			:is-spinner-loading="isLoading"
			:disabled="isDisabled"
			@click="clickHandler"
		/>
		<slot
			name="additional-content"
			v-if="$slots['additional-content']"
		/>
	</div>
</template>

<script setup lang="ts">
	import { ButtonSizeType, ButtonType } from '~~/shared/interfaces/ui';

	const emits = defineEmits(['clickBtn', 'chooseSuggestion']);
	const modelValue = defineModel('modelValue', { required: true, type: String });
	const props = withDefaults(
		defineProps<{
			readonly?: boolean;
			label?: string;
			isNeedChangeBtn?: boolean;
			isNeedAlwaysVisibleInput?: boolean;
			placeholder?: string;
			btnTitle?: string;
			isLoading?: boolean;
			isDisabled?: boolean;
			suggestions?: any;
			isVisibleSuggestionsDefault?: boolean;
		}>(),
		{}
	);

	const chooseSuggestion = (payload: any) => {
		emits('chooseSuggestion', payload);
	};

	const clickHandler = () => {
		emits('clickBtn');
	};
</script>

<style scoped lang="scss">
	.input-wrapper {
		background-color: #eaedf5;
		padding: 10px;
		border-radius: 10px;

		.label__content {
			display: flex;
			flex-direction: column;
			gap: 5px;
		}

		.btn {
			width: 100%;
			margin-top: 10px;
			min-height: 30px;
		}
	}
</style>
